import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
  delay: number;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle,
  delay
}: FAQItemProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 20
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.5,
    delay
  }} className="bg-bg-secondary border border-accent-bronze/20 rounded-sm overflow-hidden hover:border-accent-bronze/40 transition-colors duration-300" data-id="element-26">
      <button onClick={onToggle} className="w-full flex items-center justify-between p-6 text-left" aria-expanded={isOpen} data-id="element-27">
        <h3 className="font-heading text-2xl text-text-primary pr-4" data-id="element-28">
          {question}
        </h3>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="flex-shrink-0" data-id="element-29">
          <ChevronDownIcon className="w-6 h-6 text-accent-bronze" data-id="element-30" />
        </motion.div>
      </button>

      <motion.div initial={false} animate={{
      height: isOpen ? 'auto' : 0
    }} transition={{
      duration: 0.3
    }} className="overflow-hidden" data-id="element-31">
        <div className="px-6 pb-6" data-id="element-32">
          <p className="text-text-secondary font-body text-lg leading-relaxed" data-id="element-33">
            {answer}
          </p>
        </div>
      </motion.div>
    </motion.div>;
}
export function FAQSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Necesito ir al gimnasio?',
    answer: 'No necesariamente. El protocolo incluye variantes para entrenar en casa con equipamiento mínimo (mancuernas, banda elástica) y también para gimnasio completo. Vos elegís según tu contexto.'
  }, {
    question: '¿Cuánto tiempo requiere realmente?',
    answer: '90 minutos por semana divididos en 3 sesiones de 30 minutos. Lunes, Miércoles, Viernes. No hay relleno, no hay cardio innecesario. Solo tensión estructural calibrada.'
  }, {
    question: '¿Es para mi edad? Tengo 50+ años',
    answer: 'Este protocolo está DISEÑADO para +35. La sarcopenia empieza a los 30 y se acelera después de los 40. Cuanto más tarde empezás, más crítico es. Nunca es tarde, pero tampoco hay tiempo que perder.'
  }, {
    question: '¿Qué pasa si nunca entrené fuerza?',
    answer: 'Perfecto. El programa empieza desde cero con progresión estructurada. Cada ejercicio tiene su versión de iniciación. No asumimos experiencia previa, solo compromiso con tu autonomía futura.'
  }, {
    question: '¿Qué equipamiento necesito?',
    answer: 'Mínimo: Un par de mancuernas ajustables y una banda elástica (inversión de ~$15.000 ARS). Ideal: Acceso a gimnasio básico. El protocolo se adapta a lo que tengas disponible.'
  }, {
    question: '¿Hay garantía?',
    answer: 'Sí. 30 días de garantía total. Si aplicás el protocolo durante 4 semanas y no sentís cambios medibles en tu fuerza y energía, te devolvemos el 100% sin preguntas.'
  }, {
    question: '¿Cómo accedo al contenido?',
    answer: 'Acceso inmediato después del pago. Recibís por email el link de descarga del Ebook, el Plan Blindaje en PDF, y los videos demostrativos. Todo digital, todo tuyo para siempre.'
  }, {
    question: '¿Esto reemplaza a mi médico o kinesiólogo?',
    answer: 'No. Este es un protocolo de entrenamiento, no tratamiento médico. Si tenés lesiones o condiciones médicas, consultá con tu profesional antes de empezar cualquier programa de ejercicio.'
  }];
  return <section ref={ref} className="w-full bg-bg-primary py-20 px-4 sm:px-6 lg:px-8" data-id="element-34">
      <div className="max-w-4xl mx-auto" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-36">
          <h2 className="font-heading text-5xl sm:text-6xl lg:text-7xl text-text-primary mb-6" data-id="element-37">
            Preguntas <span className="text-accent-bronze" data-id="element-38">frecuentes</span>
          </h2>
          <p className="text-xl text-text-secondary max-w-2xl mx-auto font-body" data-id="element-39">
            Las respuestas directas que necesitás antes de tomar la decisión.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-40">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? null : index)} delay={index * 0.1} data-id="element-41" />)}
        </div>
      </div>
    </section>;
}